import { memo, } from 'react';
import { Container, Col, Row, } from 'react-bootstrap';
import { BzCard, BzHeading } from '../../../components';


const Themes = ({ exploreFundsThemes }) => {

    return (

        <Container fluid className='p-0'>
            <Row className='g-0 pt-4 pe-0'>
                <Col className='d-flex'>
                    <div className='pe-5 d-flex justify-content-center align-items-center'>
                        <BzHeading className='font-medium font-size6 color-text'>Themes</BzHeading>
                        <div className='icon-14 icon-info icon-dark ms-2'>&nbsp;</div>
                    </div>
                </Col>
            </Row>

            <Row className='g-0 pb-3'>
                <Col>
                    <div className='text-secondary'>Themes will let you explore funds based on your investment goals</div>
                </Col>
            </Row>

            <Row className='g-0 pe-0'>
                <Col>
                    <div className='mutual-funds-themes-card-wrap'>
                        {exploreFundsThemes.map((element, i) => (
                            <BzCard key={i} className='mutual-funds-themes-card'>
                                <Row className='g-0 mb-2'>
                                    <Col className='mutual-funds-trending-card-title'>
                                        <BzHeading className='font-medium font-size5 color-text text-wrap'>{element.fundName}</BzHeading>
                                    </Col>
                                </Row>
                                <Row className='mt-2 g-0'>
                                    <Col>
                                        <div className='font-regular font-size3 color-subtext text-truncate mf-two-line-truncate'>{element.Description}</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='d-flex justify-content-end'>
                                        <div className='icon-14 icon-forward-arrow icon-dark ms-2'>&nbsp;</div>
                                    </Col>
                                </Row>

                            </BzCard>
                        ))}
                    </div>
                </Col>
            </Row>
        </Container>

    );
};

export default memo(Themes);
